import React from "react";
import { Link } from "react-router-dom";

const MoreQueries = () => {
	return (
		<div style={{ overflowX: "hidden" }}>
			<div
				style={{ backgroundColor: "#F3C054", padding: "40px" }}
				className="container-fluid"
			>
				<div className="container">
					<div className="row">
						<div className="col">
							<h2
								style={{ fontFamily: "Poppins-Bold" }}
								className="float-left"
							>
								More Queries?
							</h2>
						</div>
						<div className="col">
							<a
								href="https://us6.list-manage.com/contact-form?u=14ad39c02ad3d8d36fdc53550&form_id=13c76439cc990bf05c7e83fb8f5c0ebb"
								style={{
									backgroundColor: "#1D1D1D",
									padding: "15px 40px 15px",
									fontFamily: "Poppins-Bold",
									borderRadius: "12px",
									fontSize: "20px",
								}}
								className="text-white btn btn-success float-right"
							>
								ContactUs{" "}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default MoreQueries;
